import React from 'react';
import AppCommon from '@appos/common';

function App() {
  return <AppCommon />;
}

export default App;
